import { render, staticRenderFns } from "./UnitDetailsPage.vue?vue&type=template&id=4431fe1b&"
import script from "./UnitDetailsPage.vue?vue&type=script&lang=js&"
export * from "./UnitDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports